import { FxIdDomainEntitiesAghanimPaymentStatus, FxIdDomainEntitiesPlutusPaymentStatus } from "@fxid/openapi-client";
import { waitFor } from "poll-until-promise";
export async function waitForAghanimPayment(storeApi, publicOrderId, options = {}) {
    const { interval = 1000, timeout = 180000 } = options;
    const result = await waitFor(async () => {
        const result = await storeApi.fxIdWebFeaturesStoreAghanimPaymentStatusPaymentStatusEndpoint(publicOrderId);
        if (result.Status === FxIdDomainEntitiesAghanimPaymentStatus.Payed) {
            return result;
        }
        throw new Error("Payment not completed");
    }, { interval, timeout });
    return result.Status;
}
export async function waitForPlutusPayment(storeApi, publicOrderId, options = {}) {
    const { interval = 1000, timeout = 180000 } = options;
    return await waitFor(async () => {
        const result = await storeApi.fxIdWebFeaturesStorePlutusPaymentStatusPaymentStatusEndpoint(publicOrderId);
        if (result.Status === FxIdDomainEntitiesPlutusPaymentStatus.Payed) {
            return result.Status;
        }
        throw new Error("Payment not completed");
    }, { interval, timeout });
}
